<template>
    <div class="bot-layout">
        <header class="bot-header">
            <div class="bot-header__logo">H</div>
            <div class="bot-header__title">Hoo-ly</div>
        </header>
        <top-nav-menu v-bind:buttons="topNav" />
        <main class="bot-content">
            <router-view />
        </main>
    </div>
</template>

<script>
import TopNavMenu from '@/components/Navs/TopNavMenu.vue';
export default {
    name: "HomePage",
    data() {
        return {
            showReport: false,
            topNav: [
                { path: "ReservationsPage", name: "Активні резерви" },
                { path: "OrdersBotPage", name: "Замовлення" }
            ]
        }
    },
    components: {
        TopNavMenu
    }
}
</script>
<style scoped>
.bot-layout {
    height: 100dvh;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f4f7fb;
}

.bot-header {
    min-height: 54px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    background: linear-gradient(135deg, #0f2641 0%, #173b5d 100%);
    box-shadow: 0 8px 22px rgba(15, 38, 65, 0.12);
}

.bot-header__logo {
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    color: #0f2641;
    background: #ffffff;
    font-size: 1.05rem;
    font-weight: 900;
    line-height: 1;
}

.bot-header__title {
    color: #ffffff;
    font-size: 1rem;
    font-weight: 900;
}

.bot-content {
    min-height: 0;
    flex: 1;
    overflow: auto;
    padding: 12px;
    -webkit-overflow-scrolling: touch;
}

@media (max-width: 767.98px) {
    .bot-content {
        padding: 8px;
    }
}
</style>
